import React from 'react';
import PropTypes from 'prop-types';

import dumbBem from 'dumb-bem';
import { makeStates } from 'dumb-bem/lib/plugins';
import tx from 'transform-props-with';

import {
  Title,
  Description,
  Block,
  Content,
  Button,
  AdobeAnim,
} from 'components/landing/components';

import mainConfig from 'config/config';
import config from 'config/landing';

import './Main.css';


const dumbMain = dumbBem('main', { plugins: [makeStates] });
const AdobeAnimWrp = tx([{ element: 'animation' }, dumbMain])('div');
const FormWrp = tx([{ element: 'form' }, dumbMain])('div');

const Header = ({
  scrollToDemoForm,
}) => {
  const onClick = () => {
    scrollToDemoForm(true);
  };

  return (
    <Block modifier="header">
      <Content modifier="header">
        <Title>Leverage your data to get more customers</Title>

        <AdobeAnimWrp>
          <AdobeAnim animationName="main_graphic_animation" />
        </AdobeAnimWrp>

        <Description>{config.header.desc}</Description>

        <FormWrp>
          <Button onClick={onClick} data-test="scroll-btn">REQUEST A DEMO</Button>
          {mainConfig.tryIterioFreeBtnEnabled && <Button modifier="reversed-colors">TRY ITERIO FREE</Button>}
        </FormWrp>
      </Content>
    </Block>
  );
};

Header.propTypes = {
  scrollToDemoForm: PropTypes.func.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/landing/pages/main/Header.js